var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpanded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.9999999403953552,0.9999999403953552,0,-19.999998807907104,20)"
  }, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,29.30908203125,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.476031015625,22.5003251875C23.476031015625,22.7213421875,23.388231015625,22.9333021875,23.231951015625,23.0895821875L23.231951015625,23.0895821875L16.321211015625,30.0003221875L23.231951015625,36.9110921875C23.388231015625,37.0673921875,23.476031015625,37.2792921875,23.476031015625,37.5002921875C23.476031015625,37.9605921875,23.102931015625,38.3336921875,22.642691015625,38.3336921875C22.421681015625,38.3336921875,22.209721015625,38.245892187500004,22.053441015625,38.0895921875L15.142696015625,31.1788321875Q14.654541015625,30.690682187500002,14.654541015625,30.0003221875Q14.6545409659545,29.3099721875,15.142696015625,28.8218121875L22.053131015625,21.9113821875L22.053131015625,21.9113821875C22.209721015625,21.7547894875,22.421681015625,21.6669921875,22.642691015625,21.6669921875C23.102931015625,21.6669921875,23.476031015625,22.0400881875,23.476031015625,22.5003251875Z",
    fillRule: "evenodd",
    fill: "#222222",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpanded);
export default __webpack_public_path__ + "media/expanded.90dae315.svg";
export { ForwardRef as ReactComponent };